import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'initiateTerminalCharge'
    ]),

    async terminalCharge(paymentData) {
      let chargeResult = {};

      try {
        chargeResult = await this.initiateTerminalCharge(paymentData);
      } catch (e) {
        this.errorNotification('Terminal Charge failed: ' + e);
        return false;
      }

      if (chargeResult.error) {
        this.errorNotification('Confirm failed: ' + confirmResult.error.message);
        return false;
      } else if (chargeResult.abandoned) {
        this.infoNotification('Terminal Payment Cancelled');
        return false;
      } else {
        this.successNotification('Tab successfully paid');
        return true;
      }
    }
  }
};
